import { Button, Drawer, Form, Space, Input, InputNumber } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo } from "../../../../context";

const EditDeduction = ({ open, close, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleEditDeduction = (values) => {
    const formdata = new FormData();
    formdata.append("id", selectedData !== null ? selectedData.id : "");

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoading(true);
    axios
      .post("user/merchant/update/edit-deduction", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Edited deduction successfully.");
          setTimeout(() => {
            rerun();
            setLoading(false);
            close();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <Drawer
      title="Edit Deduction"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="edit-deduction"
          initialValues={{
            description:
              selectedData.description !== null ? selectedData.description : "",
            amount: selectedData.amount !== null ? selectedData.amount : "",
          }}
          onFinish={handleEditDeduction}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item name="description" label="Description">
              <Input placeholder="Set description" size="large" />
            </Form.Item>

            <Form.Item
              name="amount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              //   loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
              //   disabled={timeIn === null}
            >
              {loading ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditDeduction;
